import { Trans } from "@lingui/react/macro";
import { Scale, Info, ShieldAlert } from "lucide-react";
import LegalPageLayout, {
  LegalSectionConfig,
} from "../../components/legal/LegalPageLayout";
import LegalSection from "../../components/legal/LegalSection";
import CompanyContactInfo from "../../components/legal/CompanyContactInfo";

export default function Impressum() {
  const sections: LegalSectionConfig[] = [
    {
      id: "info",
      label: <Trans>1. Information (§ 5 DDG)</Trans>,
      icon: Info,
    },
    {
      id: "dispute",
      label: <Trans>2. Dispute Resolution</Trans>,
      icon: ShieldAlert,
    },
  ];

  return (
    <LegalPageLayout
      title={<Trans>Impressum</Trans>}
      description={<Trans>Legal notice and company information.</Trans>}
      icon={Scale}
      sections={sections}
      tableOfContentsLabel={<Trans>Table of Contents</Trans>}
    >
      <LegalSection
        id="info"
        title={<Trans>Information according to § 5 DDG</Trans>}
        icon={Info}
      >
        <CompanyContactInfo email="info@soluud.de" />
      </LegalSection>

      <LegalSection
        id="dispute"
        title={<Trans>Dispute Resolution</Trans>}
        icon={ShieldAlert}
      >
        <h3 className="text-soluud-text-primary text-lg font-bold">
          <Trans>Consumer dispute resolution/universal arbitration board</Trans>
        </h3>
        <p>
          <Trans>
            We are not willing or obliged to participate in dispute resolution
            proceedings before a consumer arbitration board
            (Verbraucherschlichtungsstelle).
          </Trans>
        </p>

        <h3 className="text-soluud-text-primary mt-6 text-lg font-bold">
          <Trans>Online Dispute Resolution (ODR)</Trans>
        </h3>
        <p>
          <Trans>
            The European Commission provides a platform for online dispute
            resolution (ODR), which can be found at{" "}
            <a
              href="https://ec.europa.eu/consumers/odr"
              target="_blank"
              rel="noopener noreferrer"
              className="text-soluud-primary hover:underline"
            >
              https://ec.europa.eu/consumers/odr
            </a>
            .
          </Trans>
        </p>
      </LegalSection>
    </LegalPageLayout>
  );
}
